<template>
  <div>
    <div class="title_h1">作業可能日回答</div>
    <vab-collapse-info>
      <template slot="title">
        {{
          formatDate(
            getFieldValue('possibleDateReqIdModel.requestYearMonth', info)
          )
        }}
      </template>
      <template slot="row">
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">依頼部門</vab-col>
          <vab-col :span="8" class="word_box">
            <div class="flex_space flex_center_align">
              <div class="flex_auto line_height">
                {{
                  getFieldValue(
                    'possibleDateReqIdModel.requestDepCdModel.orgkj',
                    info
                  )
                }}
              </div>
            </div>
          </vab-col>
          <vab-col :span="4" class="title_box rline">依頼者</vab-col>
          <vab-col :span="8" class="word_box flex_center_align">
            {{
              getFieldValue(
                'possibleDateReqIdModel.requestPersonCdModel.empnmkj',
                info
              )
            }}
          </vab-col>
        </vab-row>
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">回答期限</vab-col>
          <vab-col :span="8" class="word_box">
            <div class="flex_space flex_center_align">
              <div class="flex_auto line_height">
                {{
                  getFieldValue('possibleDateReqIdModel.answerLimitDate', info)
                }}
              </div>
            </div>
          </vab-col>
          <vab-col :span="4" class="title_box rline">依頼状況</vab-col>
          <vab-col :span="8" class="word_box flex_center_align">
            {{ getEnumText(info.requestStatus, $divisions.requestStatusEnum) }}
          </vab-col>
        </vab-row>
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">協力会社</vab-col>
          <vab-col :span="20" class="word_box">
            {{ getFieldValue('requestDestCdModel.bcnfrkj', info) }}
          </vab-col>
        </vab-row>
        <vab-row class="row_box">
          <vab-col :span="4" class="title_box">DLNコメント</vab-col>
          <vab-col :span="20" class="word_box">
            <div class="pre_wrap">
              {{ getFieldValue('possibleDateReqIdModel.reqRemarks', info) }}
            </div>
          </vab-col>
        </vab-row>
      </template>
    </vab-collapse-info>

    <vab-form ref="form" :model="form">
      <div class="info_main">
        <div class="head_box flex_start flex_center_align">
          <svg-icon icon-class="edit_2_line"></svg-icon>
          <span class="hd_title">可能日選択</span>
        </div>
        <div class="h_date flex_start flex_center_align">
          <svg-icon icon-class="tryangle_down" class="h_svg"></svg-icon>
          <span class="h_title h_img_none">カレンダーの</span>
          <div class="flex_start flex_center_align m_box">
            <div class="mk_box gray"></div>
            <span class="mark_title">
              をクリックして、作業可能日を選択してください
            </span>
          </div>
        </div>
        <div class="flex_space activemk_main">
          <div class="btn_left">
            <span class="upload_btn_box blue_btn" @click="selectAll">
              すべての日を選択
            </span>
            <span class="upload_btn_box gray gray_btn" @click="clearAll">
              クリア
            </span>
          </div>
          <div class="flex_start">
            <div class="flex_start flex_center_align mk_item">
              <div class="mk_box blue"></div>
              <div class="mk_title">：作業可能日（平日・土曜）</div>
            </div>
            <div class="flex_start flex_center_align mk_item">
              <div class="mk_box red"></div>
              <div class="mk_title">：作業可能日（日曜）</div>
            </div>
          </div>
        </div>
        <vab-row :gutter="20">
          <vab-col :span="24">
            <vab-calendar ref="calender">
              <div slot="noday"></div>
              <div slot="left"></div>
              <div slot="right"></div>
            </vab-calendar>
          </vab-col>
        </vab-row>
        <div class="sure_box top_info">
          <vab-row class="row_box">
            <vab-col :span="4" class="title_box">協力会社コメント</vab-col>
            <vab-col :span="20" class="word_box nopadding2">
              <vab-textarea
                ref="answerRemarksRef"
                type="textarea"
                prop="answerRemarks"
                rows="5"
                maxlength="1170"
              ></vab-textarea>
            </vab-col>
          </vab-row>
        </div>
        <div class="flex_end mg12">
          <vab-button :btn-list="btnList"></vab-button>
        </div>
      </div>
    </vab-form>
  </div>
</template>

<script>
  import {
    workableDateRequestInfo,
    submitAnswerSchedule,
    getWorkableDateTimeList,
  } from '@/api/workableDateRequest'
  import mixinPage from '@/utils/mixinPage'
  export default {
    name: 'PWS02G06',
    mixins: [mixinPage],
    provide() {
      return {
        form: this.form,
      }
    },
    data() {
      return {
        form: {},
        info: {
          requestDepCdModel: {},
          requestPersonCdModel: {},
        },
        btnList: [
          {
            name: '回答',
            icon: 'answer',
            msg: this.$t(`validateMessage.${this.$messageCode.I00000427.name}`),
            word: this.$t(
              `validateMessage.${this.$messageCode.I00000451.name}`
            ),
            type: 'button',
            hidden: false,
            click: (row) => {
              this.sumbitAnswer(row)
            },
          },
        ],
        calenderDays: [],
      }
    },
    computed: {
      requestDestCd() {
        return this.$store.getters['user/requestDestCd']
      },
    },
    mounted() {
      this.initData()
    },
    methods: {
      formatDate(data) {
        return this.$dayjs(data).format('YYYY年M月')
      },
      // データを初期化します
      initData() {
        let possibleDateDetailId = this.$route.query?.possibleDateDetailId
        if (possibleDateDetailId) {
          this.getWorkableDateInfo(possibleDateDetailId)
        }
      },
      // 作業可能日詳細の取得
      async getWorkableDateInfo(possibleDateDetailId) {
        try {
          this.$baseColorfullLoading()
          let res = await workableDateRequestInfo(possibleDateDetailId)
          if (res) {
            this.info = res
            this.setBtnList()
            this.$nextTick(() => {
              this.$refs.answerRemarksRef.setValue(res.answerRemarks)
            })
            if (this.info?.possibleDateReqIdModel?.requestYearMonth) {
              this.$refs.calender.getTimes(
                this.info?.possibleDateReqIdModel?.requestYearMonth
              )
            }
            await this.getWorkableDateTimeList()
          }
        } finally {
          this.$baseColorfullLoading().close()
        }
      },
      setBtnList() {
        this.btnList = [
          {
            name: (() => {
              if (
                this.isEqualCodeEnum(
                  this.getFieldValue('requestStatus', this.info),
                  this.$divisions.requestStatusEnum.enum_3
                )
              ) {
                return '再回答'
              } else {
                return '回答'
              }
            })(),
            icon: (() => {
              if (
                this.isEqualCodeEnum(
                  this.getFieldValue('requestStatus', this.info),
                  this.$divisions.requestStatusEnum.enum_3
                )
              ) {
                return 'answer2'
              } else {
                return 'answer'
              }
            })(),
            msg: this.$t(`validateMessage.${this.$messageCode.I00000427.name}`),
            word: this.$t(
              `validateMessage.${this.$messageCode.I00000451.name}`
            ),
            type: 'button',
            hidden: false,
            click: (row) => {
              this.sumbitAnswer(row)
            },
          },
        ]
      },
      // ジョブの可能日時間帯を取得する
      async getWorkableDateTimeList() {
        let data = {
          possibleDateDetailId: this.info?.possibleDateDetailId,
          requestYearMonth: this.getFieldValue(
            'possibleDateReqIdModel.requestYearMonth',
            this.info
          ),
        }
        let res = await getWorkableDateTimeList(data)
        if (res?.length && res.length > 0) {
          this.$refs.calender.setCalenderTime(res)
        }
        // 设置日历选中
        // 上記②で取得した依頼状況は「"3":提出済」の場合、可能日回答を解析しすべての可能日を取得し、作業可能日カレンダーに表示する。

        if (
          this.info.possibleDateAnswer &&
          this.isEqualCodeEnum(
            this.info?.requestStatus,
            this.$divisions.requestStatusEnum.enum_3
          )
        ) {
          this.$refs.calender.setCanWorke(
            JSON.parse(this.info?.possibleDateAnswer)
          )
        }
      },
      // 回答を提出する
      async sumbitAnswer(row) {
        let info = JSON.parse(JSON.stringify(this.info))
        let submitData = { ...info }
        submitData.answerRemarks = this.form?.answerRemarks
        let list = this.$baseLodash.cloneDeep(
          this.$refs.calender.getPossibleDateAnswerList()
        )
        if (list.length == 0) {
          this.msgError(
            this.format(
              this.$t(`validateMessage.${this.$messageCode.E00000046.name}`),
              '作業可能日'
            )
          )
          return
        }
        list.filter((item) => {
          item.selectFlag = 0
        })
        submitData.possibleDateAnswer = JSON.stringify(list)
        try {
          this.$baseColorfullLoading()
          const res = await submitAnswerSchedule(submitData)
          if (!res) {
            this.msgSuccess(row.word)
            this.$closePage(this.$route.path)
            this.$routerPushAndReload({
              path: '/pws/PWS02G05',
              refresh: 'PWS02G05',
            })
          }
        } finally {
          this.$baseColorfullLoading().close()
        }
      },
      // すべて選択操作
      selectAll() {
        this.$refs.calender.selectAll()
      },
      // すべての選択をクリア
      clearAll() {
        this.$refs.calender.clearAll()
      },
    },
  }
</script>

<style lang="scss" scoped>
  .tableInfo {
    border: 1px solid #d1dae1;
    border-radius: $base-border-radius3;
    overflow: hidden;
    .ts_box {
      background: #fff;
      padding: 10px 12px;
      .title {
        font-weight: 500;
        font-size: 16px;
        color: #003350;
      }
    }
  }
  .mk_item {
    .mk_title {
      font-weight: 400;
      font-size: 14px;
      color: #000000;
    }
  }
  .activemk_main {
    margin-bottom: 10px;
  }
  .m_box {
    margin-left: 8px;
    cursor: pointer;
  }
  .mark_title {
    font-weight: 400;
    font-size: 13px;
    color: #003350;
    display: inline-block;
    padding-left: 8px;
  }
  .upload_btn_box {
    color: #0060c2;
    padding: 6px 10px 6px 10px;
    display: inline-block;
    border: 1px solid #0060c2;
    border-radius: 3px;
    margin-top: 10px;
    line-height: normal;
    cursor: pointer;
    font-weight: 500;
    font-size: 14px;
    &.gray {
      border: 1px solid #848484;
      color: #848484;
      margin-left: 8px;
    }
  }
</style>
